export const address = {
  userName: "张三",
  telNumber: "18888888888",
  provinceName: "上海市",
  cityName: "上海市",
  countryName: "浦东新区",
  detailInfo: "张江高新区嘉定园",
  addressStreetFourthStageName: "张江高新区",
  addressDetailInfoNew: "嘉定园",
};

export const invoice = {
  type: "0",
  title: "!个人",
  bankAccount: "info.bankAccount",
  bankName: "info.bankName",
  companyAddress: "info.companyAddress",
  taxNumber: "440300123456789",
  telephone: "info.telephone",
};
